import Marquee from "react-fast-marquee";
import { SERVICES } from "@/lib/siteData";

export default function ServicesMarquee({ variant = "dark" }) {
  const isDark = variant === "dark";
  return (
    <div
      data-testid="services-marquee"
      className={`py-5 border-y ${
        isDark
          ? "bg-[#1A1A18] text-[#F6F5F2] border-stone-800"
          : "bg-[#F6F5F2] text-stone-900 border-[#D2D0C9]"
      }`}
    >
      <Marquee speed={42} gradient={false} pauseOnHover>
        {SERVICES.concat(SERVICES).map((s, i) => (
          <span
            key={`${s.slug}-${i}`}
            className="font-display text-lg md:text-2xl tracking-tight px-8 flex items-center"
          >
            {s.title}
            <span className="mx-8 text-[#D05322]">●</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
